import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { categories } from '../data/content';
export function WhatsInside() {
  return <section aria-labelledby="inside-heading" className="bg-paper py-16 sm:py-24" data-id="element-238" data-mp="kw7zx52hhunz">
      <Container data-id="element-239" data-mp="kylu7bpcb2uh">
        <SectionHeading id="inside-heading" title={<>
              <span className="pop-sm-blue" data-id="element-241" data-mp="b6g6ie64f7l3">1,200+</span> 3D Paper Crafts
              <span className="block" data-id="element-242" data-mp="b4brp16ooo61">
                for Every Kind of <span className="pop-sm-orange" data-id="element-243" data-mp="fy6kcu49odh9">Imagination</span>
              </span>
            </>} subtitle="No more searching for activities every afternoon. Choose a project, print it at home and start building." data-id="element-240" data-mp="pv2kock0htaq" />

        <ul className="mx-auto mt-12 grid max-w-[980px] grid-cols-2 gap-2.5 sm:mt-16 sm:gap-5" data-id="element-244" data-mp="72ql1xkqt64a">
          {categories.map(category => <li key={category.title} className="group flex flex-col overflow-hidden rounded-xl2 border border-hairline bg-white shadow-paper transition-shadow duration-200 hover:shadow-lift" data-id="element-245" data-mp="3tckswl3p52bo">
              <div className="relative" data-id="element-246" data-mp="37ub66ks5ossm">
                <img src={category.image} alt={category.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-247" data-mp="3lulx1ntgu7ds" />
                <span aria-hidden="true" className="absolute -bottom-5 left-3.5 flex h-10 w-10 items-center justify-center rounded-2xl border border-hairline bg-white text-[19px] shadow-paper sm:-bottom-6 sm:left-5 sm:h-12 sm:w-12 sm:text-[22px]" data-id="element-248" data-mp="2u36d61jamyr9">
                  {category.emoji}
                </span>
              </div>

              <div className="flex flex-1 flex-col px-3.5 pb-5 pt-8 sm:px-6 sm:pb-6 sm:pt-9" data-id="element-249" data-mp="2y36vvydfdw44">
                <h3 className="pop-card font-display text-[15px] font-extrabold leading-tight tracking-[-0.015em] text-ink sm:text-[20px]" data-id="element-250" data-mp="2ad2rvpwbrucl">
                  {category.title}
                </h3>
                <p className="mt-2 text-[13px] font-semibold leading-[1.4] text-muted sm:mt-2.5 sm:text-[15px]" data-id="element-251" data-mp="9bd9z2jrm8rb">
                  {category.description}
                </p>
              </div>
            </li>)}
        </ul>
      </Container>
    </section>;
}